import PunchTheClock from '@/components/newPages/student/punchTheClock/index';

const punchTheClock = [
    // 打卡
    {
        path: '/punchTheClock/index',
        name: 'punchTheClock',
        component: PunchTheClock
    }
];
export default punchTheClock;



// WEBPACK FOOTER //
// ./src/router/punchTheClock.js